export default "__VITE_ASSET__rdzZJ5Uy__"